module.exports = __webpack_public_path__ + "static/media/grpconv_100.ab2a3fbc.ico";